module.exports = __webpack_public_path__ + "img/cyan.b76ad31f.png";